import * as types from './types';

const Desc = () => (
  <span>Crea o modifica i dati anagrafici della/e tua/e attività.</span>
);

const initialState = {
  listData: {
    id: 'restaurants',
    title: 'Anagrafica attività',
    description: <Desc />,
    href: '/profile/restaurant/:id',
    createLink: '/profile/restaurant/create',
    loading: false,
    items: [],
  },
  listFetched: false,
  currentItem: {},
  currentItemInProcess: false,
  deleteInProcess: false,
  updateOrCreateInProcess: false,
  errors: null,
};

const restaurantReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESTAURANTS_GET_REQUEST:
      return {
        ...state,
        listData: {
          ...state.listData,
          loading: true,
        }
      };
    case types.RESTAURANTS_GET_FAILURE:
      return {
        ...state,
        listData: {
          ...state.listData,
          loading: false,
        }
      };
    case types.RESTAURANTS_RESET_LIST_DATA:
      return {
        ...state,
        listData: action.payload,
        listFetched: false,
      };
    case types.RESTAURANTS_GET_SUCCESS:
      return {
        ...state,
        listFetched: true,
        listData: {
          ...state.listData,
          items: action.payload,
          loading: false,
        },
      };
    case types.RESTAURANT_BY_ID_GET_REQUEST:
      return {
        ...state,
        currentItemInProcess: true,
      };
    case types.RESTAURANT_BY_ID_GET_FAILURE:
      return {
        ...state,
        currentItemInProcess: false,
      };
    case types.RESTAURANT_BY_ID_GET_SUCCESS:
      return {
        ...state,
        currentItem: action.payload,
        currentItemInProcess: false,
      };
    case types.RESTAURANT_CREATE_OR_UPDATE_REQUEST:
      return {
        ...state,
        updateOrCreateInProcess: true,
      };
    case types.RESTAURANT_CREATE_OR_UPDATE_SUCCESS:
      return {
        ...state,
        updateOrCreateInProcess: false,
      };
    case types.RESTAURANT_CREATE_OR_UPDATE_FAILURE:
      return {
        ...state,
        errors: action.payload,
        updateOrCreateInProcess: false,
      };
    case types.RESTAURANT_DELETE_REQUEST:
      return {
        ...state,
        deleteInProcess: true,
      };
    case types.RESTAURANT_DELETE_SUCCESS:
    case types.RESTAURANT_DELETE_FAILURE:
      return {
        ...state,
        deleteInProcess: false,
      };
    default:
      return state;
  }
};

export default restaurantReducer;
